import React from 'react';
import AnchorTemporaryDrawer from './Drawer';
import logo from './../assets/logo_launcher.png'

export default function AppBar() {
  return (
    <nav className="w-full flex items-center justify-between bg-[#BE1F18] shadow-md">
      <img src={logo} className="h-20 w-24 ml-4" alt="Logo" />
      <AnchorTemporaryDrawer />
    </nav>
  );
}
